function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "dollar");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Dashboard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Home-page-/-Student",
  transform: "translate(-621.000000, -463.000000)",
  fill: "#000000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-12",
  transform: "translate(48.000000, 266.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-6-Copy",
  transform: "translate(339.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(19.937695, 190.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "dollar",
  transform: "translate(215.216338, 7.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.42436829,12 C4.70835929,12 3.09503981,11.3759062 1.88163724,10.2426562 C0.668234683,9.10940625 0,7.60265625 0,6 C0,4.39734375 0.668259778,2.89061719 1.88163724,1.75734375 C3.09501471,0.624070312 4.70835929,0 6.42436829,0 C8.14037729,0 9.75369678,0.62409375 10.9670993,1.75734375 C12.1805019,2.89059375 12.8487366,4.39734375 12.8487366,6 C12.8487366,7.60265625 12.1804768,9.10938281 10.9670993,10.2426562 C9.75372188,11.3759297 8.14037729,12 6.42436829,12 Z M6.42436829,0.75 C3.32476116,0.75 0.803046037,3.10514062 0.803046037,6 C0.803046037,8.89485937 3.32476116,11.25 6.42436829,11.25 C9.52397542,11.25 12.0456906,8.89485937 12.0456906,6 C12.0456906,3.10514062 9.52397542,0.75 6.42436829,0.75 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.42436829,5.625 C5.87086881,5.625 5.42056075,5.2044375 5.42056075,4.6875 C5.42056075,4.1705625 5.87086881,3.75 6.42436829,3.75 C6.97786777,3.75 7.42817584,4.1705625 7.42817584,4.6875 C7.42817584,4.89459375 7.60793268,5.0625 7.82969886,5.0625 C8.05146504,5.0625 8.23122188,4.89459375 8.23122188,4.6875 C8.23122188,3.88591406 7.62948944,3.2135625 6.82589131,3.04251562 L6.82589131,2.625 C6.82589131,2.41790625 6.64613448,2.25 6.42436829,2.25 C6.20260211,2.25 6.02284528,2.41790625 6.02284528,2.625 L6.02284528,3.04251562 C5.21924714,3.2135625 4.61751471,3.88591406 4.61751471,4.6875 C4.61751471,5.61799219 5.42806421,6.375 6.42436829,6.375 C6.97786777,6.375 7.42817584,6.7955625 7.42817584,7.3125 C7.42817584,7.8294375 6.97786777,8.25 6.42436829,8.25 C5.87086881,8.25 5.42056075,7.8294375 5.42056075,7.3125 C5.42056075,7.10540625 5.24080391,6.9375 5.01903773,6.9375 C4.79727155,6.9375 4.61751471,7.10540625 4.61751471,7.3125 C4.61751471,8.11408594 5.21924714,8.7864375 6.02284528,8.95748437 L6.02284528,9.375 C6.02284528,9.58209375 6.20260211,9.75 6.42436829,9.75 C6.64613448,9.75 6.82589131,9.58209375 6.82589131,9.375 L6.82589131,8.95748437 C7.62948944,8.7864375 8.23122188,8.11408594 8.23122188,7.3125 C8.23122188,6.38200781 7.42067238,5.625 6.42436829,5.625 Z",
  id: "Path"
})))))));

var SvgDollar = function SvgDollar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "12px",
    viewBox: "0 0 15 12",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDollar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dollar.51bdbc51.svg";
export { ForwardRef as ReactComponent };